export default {
  instance: {
    creation: {
      title: 'Création d\'instance',
    },
    detail: {
      title: 'Instance',
      form: {
        nom: 'Nom',
        id: 'ID',
        typeInstance: 'Type',
        referent: {
          title: 'Référent',
          detail:
            'Le référent est l\'interlocuteur privilégié pour cette instance',
        },
        description: 'Description',
        urlSharepoint: 'Url Sharepoint',
        dateDebut: 'Date de début d\'existence',
        dateFin: 'Date de fin d\'existence',
        gestionnaires: {
          title: 'Filiale de (0)|Filiale de (1)|Filiale de ({count})',
          add: 'Ajouter un gestionnaire',
          remove: 'Supprimer un gestionnaire',
          dialog: {
            description:
              'Sélectionner une personne physique en tant que gestionnaire',
          },
        },
        panel: {
          participants: {
            search: 'Chercher un participant',
            addParticipant: 'Ajouter comme participant',
            addGestionnaire: 'Ajouter comme gestionnaire',
            referent: 'Ajouter comme référent',
            checkReferent: 'Référent',
            add: 'Ajouter',
          },
        },
      },
    },
    ajouterParticipant: {
      roleManquant: 'Veuillez sélectionner un rôle',
    },
  },
};
